// extracted by mini-css-extract-plugin
module.exports = {"header":"header-6flEB","option":"option-1NPvn","small":"small-3h3Yv","paid":"paid-3WQxg"};